import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
  private router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request);
    // .pipe(
    //   catchError((error: HttpErrorResponse) => {
    //     if (error.url?.startsWith(ENVIRONMENT.API_URL) && error.status === 404) {
    //       this.router.navigate(["/under-construction"]);
    //     }
    //     throw new Error("api-error: => , " + error);
    //   })
    // );
  }
}
